import { render, staticRenderFns } from "./ItemListHistoryComponent.vue?vue&type=template&id=633321ea&scoped=true&"
import script from "./ItemListHistoryComponent.vue?vue&type=script&lang=js&"
export * from "./ItemListHistoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633321ea",
  null
  
)

export default component.exports